import {
  Box,
  formatDateWithTimeAndTimezone,
  Notification,
} from '@omnipresentgroup/design-system';
import { useCutoffDates, useEmployee } from '@omnipresentgroup/domains';
import { useMemo } from 'react';

export const EmployeeCutOffNotification = ({
  employeeId,
  description,
}: {
  employeeId: string;
  description?: string;
}) => {
  const { data: employee } = useEmployee({ id: employeeId });

  const { data: cutoffDatesData } = useCutoffDates({
    legalEntityId: employee?.legalEntityId,
    enabled: Boolean(employee?.legalEntityId),
  });

  const nextCutOffDate = useMemo(
    () => cutoffDatesData?.[0]?.cutoffDates?.[0],
    [cutoffDatesData],
  );

  return nextCutOffDate ? (
    <Box data-testing="blackout">
      <Notification
        id="employee-cutoff-alert"
        intent="info"
        title={`The cutoff date for this employee is ${formatDateWithTimeAndTimezone(
          nextCutOffDate,
        )}`}
        description={description}
      />
    </Box>
  ) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <></>
  );
};
